export enum AVATAR_SIZE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}
export enum AVATAR_FALLBACK_TONE {
  NEUTRAL = 'neutral',
  BRAND = 'brand',
}
